import { useEffect } from "react";

const useScrollToTopOnChange = <T>(trigger: T) => {
    useEffect(() => {
        window.scrollTo({
            top: 0,
            behavior: "smooth",
        });
    }, [trigger]);
};

export default useScrollToTopOnChange;
